import { render, staticRenderFns } from "./TheContact.vue?vue&type=template&id=7f8fd628"
import script from "./TheContact.vue?vue&type=script&lang=js"
export * from "./TheContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports